<template>
  <img class="tw-relative tw-right-4" alt="site logo" :src="src" />
</template>
<script setup lang="ts">
const src = new URL("@/assets/branding/Titan_Logo.svg", import.meta.url).href;
</script>
